export default __webpack_public_path__ + "static/IMG_4994-5221457e787ce1ee3ee843701fb040c3.jpg";